import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import "./userSetting.scss";
import { useSetting } from "../../../hooks/useSetting";
import { useTranslation } from "react-i18next";
import "../../../i18n";

function AccountSettings() {
  const userName = localStorage.getItem("username");
  const emailUser = localStorage.getItem("emailUser");
  const [country, setCountry] = useState(localStorage.getItem("country") || "");

  const [fullName, setFullName] = useState(
    localStorage.getItem("fullName") || ""
  );
  const [gender, setGender] = useState(
    localStorage.getItem("gender") || "Female"
  );
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");
  const [defaultLanguage, setDefaultLanguage] = useState(
    localStorage.getItem("setLangu") || "en"
  );

  const { settingPost, isLoading } = useSetting();
  const { t } = useTranslation();
  const changeGenderHandler = (e) => {
    const selectedGender = e.target.value;
    setGender(selectedGender);
    localStorage.setItem("gender", selectedGender); // ✅ fixed
  };

  const nameChangeHandler = (e) => {
    const enteredName = e.target.value;
    setFullName(enteredName);
    localStorage.setItem("fullName", enteredName);
  };
  const handelCointryChange = (e) => {
    const enteredCountry = e.target.value;
    setCountry(enteredCountry);
    localStorage.setItem("country", enteredCountry);
  };

  const updateHandler = async (event) => {
    event.preventDefault();
    const response = await settingPost(
      fullName,
      gender,
      theme,
      defaultLanguage,
      country
    );

    if (response === "success") {
      alert("Profile updated successfully!");
    } else {
      alert("Failed to update profile. Please try again.");
    }
  };

  return (
    <div className="settingsDecription">
      <p>{t("accountsettindsDes")}.</p>

      <Form onSubmit={updateHandler}>
        <div className="mb-3 col-4">
          <label htmlFor="name" className="form-label m-0 p-0">
            {t("yourName")}
          </label>
          <input
            id="name"
            type="text"
            className="form-control"
            placeholder="Please enter your full name"
            value={fullName}
            onChange={nameChangeHandler}
          />
        </div>

        <div className="mb-3 col-4">
          <label htmlFor="username" className="form-label">
            {t("userName")}
          </label>
          <input
            id="username"
            type="text"
            className="form-control"
            value={"@" + userName}
            readOnly
          />
        </div>

        <div className="mb-3 col-4">
          <label className="form-label">Email</label>
          <input
            type="text"
            className="form-control"
            value={emailUser}
            readOnly
          />
        </div>

        <div className="mb-3 col-4">
          <label className="form-label"> {t("gender")} </label>
          <select
            className="form-control"
            id="sel1"
            value={gender}
            onChange={changeGenderHandler}
          >
            <option> {t("female")} </option>
            <option> {t("male")} </option>
          </select>
        </div>

        <div className="mb-3 col-4">
          <label className="form-label"> {t("country")} </label>
          <input
            className="form-control"
            id="sel1"
            type="text"
            placeholder="Please enter your country"
            value={country}
            onChange={handelCointryChange}
          ></input>
        </div>

        <div className="row">
          <div className="col">
            <Button
              className="reset-consent-button bg-blue  fw-bold mt-3"
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? "Updating..." : "Update"}
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
}

export default AccountSettings;
